// services/euroDisplay.js — правилото „само евро" (решение на Макс, 01.09.2026).
//
// Двойното обозначаване € + лв. остава САМО на документи, издадени ПРЕДИ
// 01.09.2026 — те се печатат както са издадени, завинаги. Всичко от тази дата
// нататък е само в евро. Заварен документ в друга валута (BGN/USD) се печата
// каквато е, без превалутиране и без двойно.
//
// Сверено в lex.bg на 01.09.2026: чл. 15, ал. 2 от Закона за въвеждане на
// еврото (изм. ДВ, бр. 65/2025) — задължителният период за двойно обозначаване
// беше 08.08.2025 – 08.08.2026 и се отнасяше за цени към потребители, не за
// фактури. Тоест границата тук е изцяло вътрешно решение, не законов срок.
//
// Ползва се и от бекенда (PDF-ите), и от екраните (Vite го внася в src/).

const BGN_PER_EUR = 1.95583;
const DUAL_BEFORE = '2026-09-01'; // издадено ПРЕДИ тази дата → двойно

// Двойно се показва само при евро и само за старите документи. Без дата не
// се гадае — безопасното е само евро (датата винаги я има при истински запис).
function showDual(issueDateIso, currency) {
  const cur = currency || 'EUR';
  const day = String(issueDateIso || '').slice(0, 10);
  return cur === 'EUR' && !!day && day < DUAL_BEFORE;
}

function toBgn(n) { return Math.round((Number(n) || 0) * BGN_PER_EUR * 100) / 100; }

// Сума за PDF: „100.00 EUR / 195.58 BGN" (старо), „100.00 EUR" (ново),
// „100.00 BGN" (заварена друга валута — каквато е, без превалутиране).
function pdfAmount(n, issueDateIso, currency) {
  const cur = currency || 'EUR';
  const num = (Number(n) || 0).toFixed(2);
  if (showDual(issueDateIso, cur)) return num + ' EUR / ' + toBgn(n).toFixed(2) + ' BGN';
  return num + ' ' + cur;
}

// Бележката за фиксирания курс има смисъл само където има две валути.
function rateNote(issueDateIso, currency) {
  return showDual(issueDateIso, currency) ? ' Курс на еврото: 1 EUR = 1.95583 BGN.' : '';
}

module.exports = { BGN_PER_EUR, DUAL_BEFORE, showDual, toBgn, pdfAmount, rateNote };
